export const PENDING = 'pending';
export const PROCESSING = 'processing';
export const ON_HOLD = 'on-hold';
export const COMPLETED = 'completed';
export const CANCELLED = 'cancelled';
export const REFUNDED = 'refunded';
export const FAILED = 'failed';
export const TRASH = 'trash';

const statusOptions = [
  { label: 'Pending', value: PENDING },
  { label: 'Processing', value: PROCESSING },
  { label: 'On hold', value: ON_HOLD },
  { label: 'Completed', value: COMPLETED },
  { label: 'Cancelled', value: CANCELLED },
  { label: 'Refunded', value: REFUNDED },
  { label: 'Failed', value: FAILED },
  { label: 'Trash', value: TRASH },
];

export default Object.freeze(statusOptions);
